import React, { useEffect, useRef, useState } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Dropdown } from 'react-bootstrap';
import styles from 'styles/Report.module.scss';
import classnames from 'classnames';
import { HEADER_MENU } from 'constants/header';
import { getColor, getColorMenu } from 'store/settings';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDown, ChevronUp } from 'react-feather';
import { useRouter } from 'next/router';
import { getViewMode } from 'store/auth';
import { USER_ROLES } from 'constants/constants';
import { havePermissions } from 'helpers';
import styled from '@emotion/styled';
import { useUser } from 'hooks';
import {
  fetchAdminData,
  fetchGraphicalInformation,
  fetchInstructorData,
  getAdminData,
  getLearnerData,
  getInstructorData,
  fetchLearnerData,
} from 'store/units';
import { getSelectedCentre } from 'store/master';
import { omitViewModes } from 'hooks/permission';
const newMenu = ({ setOpen }) => {
  const route = useRouter();
  const user = useUser();
  const dispatch = useDispatch();
  const viewMode = useSelector(getViewMode);
  const adminValues = useSelector(getAdminData);
  const instructorValues = useSelector(getInstructorData);
  const learnerValues = useSelector(getLearnerData);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const changeHandler = () => {
    setOpen(true);
  };

  const selectedCentre = useSelector(getSelectedCentre);
  const menuRef = useRef();
  const [menuBarCheckBox, setMenuBarCheckBox] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event.target)) {
        setMenuBarCheckBox(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    (viewMode == USER_ROLES.ADMIN ||
      viewMode == USER_ROLES.SUPER_ADMIN ||
      viewMode == USER_ROLES.CENTRE_ADMIN) &&
      dispatch(
        fetchAdminData(
          selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
        ),
      );
    viewMode == USER_ROLES.INSTRUCTOR &&
      dispatch(
        fetchInstructorData(
          selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
        ),
      );

    dispatch(fetchGraphicalInformation(user._id));
    viewMode == USER_ROLES.LEARNER &&
      dispatch(
        fetchLearnerData(
          selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
        ),
      );
    ``;
  }, [selectedCentre, viewMode]);
  const countValues = (val) => {
    let count = 0;
    if (
      viewMode === USER_ROLES.ADMIN ||
      viewMode === USER_ROLES.SUPER_ADMIN ||
      viewMode === USER_ROLES.CENTRE_ADMIN
    ) {
      if (
        typeof adminValues == 'object'
          ? adminValues.hasOwnProperty(val.countValue)
          : false
      ) {
        count = adminValues[val.countValue];
      }
    }
    if (viewMode === USER_ROLES.INSTRUCTOR) {
      if (
        typeof instructorValues == 'object'
          ? instructorValues.hasOwnProperty(val.countValue)
          : false
      ) {
        count = instructorValues[val.countValue];
      }
    }
    if (viewMode === USER_ROLES.LEARNER) {
      if (
        typeof learnerValues == 'object'
          ? learnerValues.hasOwnProperty(val.countValue)
          : false
      ) {
        count = learnerValues[val.countValue];
      }
    }
    return count;
  };

  const renderHeaderMenu = (dt, index) => {
    let content = dt.viewModeAccess.some((dt) => dt == viewMode) &&
      (dt?.userAccess
        ? havePermissions(dt?.userAccess, user, viewMode)
        : true) &&
      (dt?.menuValue == 'cms' ? metaData?.cmsHomePage : true) && (
        <section className="" key={index}>
          <span className="lesson-label-tittle">{dt?.label}</span>
          <span className="lesson-label-tittle menu-header">{dt?.name}</span>
          <hr className={styles.header_menu_heading_line} />
          {dt?.children.map((item) => renderMenuItems(item))}
        </section>
      );
    return content;
  };

  const renderMenuItems = (item) => {
    let content = (item?.isSuperAdmin &&
    !omitViewModes(viewMode, {
      addValues: [USER_ROLES.INSTRUCTOR, USER_ROLES.CENTRE_BL],
    })
      ? user?.roles?.includes(USER_ROLES.SUPER_ADMIN)
      : item.viewModeAccess.some((vl) => vl == viewMode)) &&
      (item?.userAccess && !item?.isSuperAdmin
        ? havePermissions(item?.userAccess, user, viewMode)
        : true) &&
      (item?.menuValue == 'certificate' ||
      item?.menuValue == 'reportcertificate'
        ? metaData?.certificate
        : true) && (
        <Stylescal>
          <div
            role="button"
            style={{ '--gap': '.5rem' }}
            className={`${
              item?.activeStatus.includes(route?.pathname)
                ? 'childran-menu-items'
                : 'childran-menu-hover'
            } d-flex align-items-center dynamic-gap-v`}
            onClick={() => handleRoute(item)}
          >
            <span className="view-page-name">{item?.icons}</span>
            <span className="view-page-name">
              {viewMode === USER_ROLES.LEARNER
                ? item?.label?.learner ?? item?.label
                : item?.label?.admin ?? item?.label}
            </span>
            {countValues(item) ? (
              <span class="w3-badge w3-gray menu-badge">
                {countValues(item)}
              </span>
            ) : null}
          </div>
        </Stylescal>
      );
    return content;
  };

  const handleRoute = async (val) => {
    setMenuBarCheckBox(false);

    let hasCurrentPath =
      viewMode === USER_ROLES.LEARNER
        ? val?.pathUrl?.learner ?? val?.pathUrl
        : val?.pathUrl?.admin ?? val?.pathUrl;

    hasCurrentPath !== route.pathname && (await route.push(hasCurrentPath));
  };
  const colorStatus = useSelector(getColor);
  const menuColor = useSelector(getColorMenu);
  const Stylescal = styled.div`
    & {
      padding: 4px 0px;
    }
    .childran-menu-hover:hover .view-page-name {
      color: ${menuColor} !important;
    }
    .childran-menu-hover:hover .view-page-name svg.creditsvgicon {
      fill: ${menuColor} !important;
    }
    .childran-menu-items .view-page-name {
      color: ${menuColor} !important;
      & > svg.creditsvgicon {
        fill: ${menuColor};
      }
    }
  `;
  return (
    <div ref={menuRef} className="">
      <div
        className={classnames(
          'menu-icon position-relative',
          styles['menu-icon'],
        )}
      >
        <button
          data-menu={menuBarCheckBox}
          className="btn btn-bg-color menubtn p-0"
          style={{
            backgroundColor: 'white',
            color: `${colorStatus}`,
            borderColor: `${colorStatus}`,
          }}
          onClick={() => {
            changeHandler();
            setMenuBarCheckBox(!menuBarCheckBox);
          }}
        >
          <span>Explore</span>
          <ChevronUp className={`${styles.menu_open}`} />
        </button>
      </div>

      <div
        ref={menuRef}
        style={{
          transform: ` translate(${
            viewMode === USER_ROLES.LEARNER ? '-50%' : '-10%'
          },  ${viewMode !== USER_ROLES.ADMIN ? 20 : 10}%)`,
        }}
        data-menu={menuBarCheckBox}
        className={`${styles.dropdown_parant_manu} position-absolute`}
      >
        <div
          data-menu={menuBarCheckBox}
          data-viewmode={viewMode}
          className={`parent-menu-items ${styles.header_animate}`}
        >
          {HEADER_MENU.map((dt, index) => renderHeaderMenu(dt, index))}
        </div>
      </div>
    </div>
  );
};

export default newMenu;
